import {makeReducer, match} from 'web-app/util/redux';
import {type ModalState, close, open} from 'web-app/react/modals-container/types';

import * as Actions from './actions';
import {type GetPayoutDetailsQuery} from './__generated__/queries.api-types';

export type Mode = 'WithId' | 'Prefetched';

export type PayoutDetailsModalState = ModalState<
    | {mode: 'WithId'; payoutId: string}
    | {
          mode: 'Prefetched';
          prefetchedPayout: GetPayoutDetailsQuery['payments']['getPayout'];
          overrideTitle?: string;
          explanation?: string;
      }
>;

export default makeReducer<PayoutDetailsModalState>(
    [
        match(Actions.show, (_, {payload}) => {
            return open({
                mode: 'WithId',
                payoutId: payload.payoutId,
            } as {mode: 'WithId'; payoutId: string});
        }),
        match(Actions.showWithPrefetched, (_, {payload}) => {
            return open({
                mode: 'Prefetched',
                prefetchedPayout: payload.prefetchedPayout,
                overrideTitle: payload.overrideTitle,
                explanation: payload.explanation,
            } as {mode: 'Prefetched'; prefetchedPayout: GetPayoutDetailsQuery['payments']['getPayout']});
        }),
        match(Actions.hide, () => {
            return close();
        }),
    ],
    close(),
);
